<!-- @if (isLoading) {
    <div class="loading-body">
      <app-loading class=" loading-container" [text]="'Loading'"></app-loading>
    </div>
  } @else { -->
<div class="modal-body">
  <div
    class="v-center text-center d-flex flex-column align-items-center justify-content-center"
  >
    <img
      src="assets/images/virtusa-icons/caution-red.svg"
      alt="caution"
      width="50px"
      height="60px"
    />
    <span class="header-18"> {{ configs!.title || "Deletion Error" }} </span>
    <span class="accello-general-text5">
      {{ configs.subTitle}}
    </span>
  </div>

  <div class="container">
    <div class="d-flex flex-column">
      <span class="accello-general-text14"
        >{{ configs.cautionMessage1 }} </span
      >
      <span class="accello-general-text14"
      >{{ configs.cautionMessage2 }} </span
      >
    </div>
    <span class="accello-general-text14 darker fst-italic">{{configs.tableTitle}}</span>
    <div class="overflow-auto table-div">
      <app-zorro-table
        tableId="del-caution"
        [data]="tableData"
        [columns]="columns"
        [options]="{ expandable: true }"
        (handleActions)="handleTableActions($event)"
      ></app-zorro-table>
    </div>

    <div class="d-flex flex-column">
      <span class="accello-general-text14 darker">What You Can Do:</span>
      <span class="accello-general-text14">
        {{configs.footerMessage1}}</span
      >
      <span class="accello-general-text14"
        >{{configs.footerMessage2}}</span
      >
    </div>
  </div>

  <div class="d-flex justify-content-end mt-3">
    <button
      class="btn btn-accello-secondary mx-1"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>

    <button
      class="btn btn-accello-primary-light mx-1"
      (click)="this.activeModal.close(true)"
      *ngIf="configs.deleteButtonText"
    >
      {{configs.deleteButtonText}}
    </button>
  </div>
</div>
